import { OfflineState } from '@/state/offline-management'
import { offlineStateActions } from '@/state/offline-management/actions'
import { Popconfirm, Tooltip } from 'antd'
import { FaWifi } from 'react-icons/fa6'

export default function OnlineIndicator() {
  const componentToRender = () => (
    <Tooltip title='Conectado a internet' placement='bottom'>
      <FaWifi className='indicator online' />
    </Tooltip>
  )

  if (OfflineState.existNetworkConnection.value) {
    return (
      <Popconfirm
        title={'¿Deseas ingresar al modo sin conexión?'}
        onConfirm={() => offlineStateActions.switchConnection()}
        okText='Sí, desconectar'
      >
        {componentToRender()}
      </Popconfirm>
    )
  }

  if (!OfflineState.existNetworkConnection.value) {
    return componentToRender()
  }
}
